<template>
  <div class="month-picker relative w-fit border flex justify-center gap-[4px] rounded items-center px-[8px] min-h-[32px] cursor-pointer [&_.month-year-label]:cursor-pointer [&_.month-year-label]:py-[6px] [&_.month-picker-wrapper]:!min-w-0 [&_.month-picker-wrapper]:w-full [&_.month-picker-wrapper]:h-full [&_.date-popover]:min-w-[200px] [&_.date-popover]:!-translate-x-[calc(50%-4px)] [&_.date-popover]:!translate-y-2 [&_.date-popover]:!z-[100]">
    <div class="text-[13px] pointer-events-none z-10 whitespace-nowrap">
      {{ formatMonthText(internalMonth) }}
    </div>
    <b-icon
      icon="chevron-down"
      class="text-[16px] pointer-events-none text-[#A0A0A0]"
    />
    <div class="absolute inset-0 z-20">
      <MonthlyPicker
        v-model="internalMonth"
        :month-labels="monthlabel"
        date-format="MMM YYYY"
        style="width: 100%; height: 100%;"
        input-class="opacity-0 w-full h-full cursor-pointer m-0 p-0 border-0"
        :clear-option="false"
        :alignment="'center'"
        :selected-background-color="'#F95031'"
        :max="moment()"
        @selected="handleMonthChange"
      />
    </div>
  </div>
</template>

<script>
import MonthlyPicker from 'vue-monthly-picker'
import { LABELMONTH } from '@/libs/filterDate'
import moment from 'moment'
import { formatMonthText } from '../config'

export default {
  name: 'MonthFilter',
  components: {
    MonthlyPicker,
  },
  props: {
    month: { type: [Date, String, Object], required: true },
  },
  data() {
    return {
      moment,
      monthlabel: LABELMONTH,
    }
  },
  computed: {
    internalMonth: {
      get() {
        return this.month
      },
      set(val) {
        this.$emit('update:month', val)
      },
    },
  },
  methods: {
    formatMonthText,
    handleMonthChange() {
      this.$emit('month-change', this.internalMonth)
    },
  },
}
</script>
